import { colors } from 'common/colors';
import styled from 'styled-components';
import {Button} from 'antd';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${colors.mainBlack};
  min-height: 400px;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  overflow-y: scroll;
`;

export const ScannerBox = styled.div`
  align-items: center;
  text-align: center;
  height: 300px;
  width: 300px;
  border: 1px solid white;
  border-radius: 8px;
`;

export const ScannerTypes = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  gap: 50px;
`;

export const LabelText = styled.div`
  color: ${colors.secondaryGray};
`;

export const MainText = styled.div`
  font-weight: 700;
  font-size: 22px;
`;

export const CountContainer = styled.div`
  width: 100px;
  background: ${colors.mainGray};
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 10px;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-item: center;
  gap: 10px;
  margin: 10px 0px;
`;

export const StyledButton = styled(Button)`
  &&& {
    background: ${colors.mainBlack};
    color: white;
    border: white solid 2px;
    font-size: 18px;
    font-weight: 600;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;

    &:hover {
      border-color: ${colors.mainGray};
      background: ${colors.secondaryGray};
      color: ${colors.mainBlack};
    }
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 20px;
  gap: 10px;
`;

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  background: ${colors.mainBlack};
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const FooterMode = styled.div`
  height: 100%;
  width: 50%;
  padding: 10px 20px;
  font-size: 18px;
  border-right: 2px solid ${colors.secondaryGray};
`;

export const FooterWarehouse = styled.div`
  color: white;
  font-weight: 700;
  font-size: 18px;
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
  text-align: right;
`;

export const DisplayBox = styled.div`
  max-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 12px;
  margin: 20px 0px;
`;

export const DisplayLabel = styled.div`
  background: ${colors.secondaryGray};
  color: black;
  font-size: 28px;
  font-weight: 800;
  padding: 12px;
  border-radius: 8px;
`;

export const CameraTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: 800;
  font-size: 22px;
`;

